module.exports = __webpack_public_path__ + "z/proximanova-regular-webfont.122a9ce1.svg";